import type { ProjectSearchResultDto } from '@tms/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api-client';
import { queryKeys } from '../../lib/query-keys';

/** Debounced project search; `term` is expected to be already debounced. */
export const useProjectSearch = (projectCode: string, term: string) =>
  useQuery({
    queryKey: queryKeys.search(projectCode, term),
    queryFn: ({ signal }) =>
      api.get<ProjectSearchResultDto>(`/projects/${projectCode}/search`, { q: term }, signal),
    enabled: term.trim().length > 0,
    staleTime: 30 * 1000,
  });
